import { createAuthClient } from 'better-auth/react';
import { emailOTPClient, inferAdditionalFields } from 'better-auth/client/plugins';
import * as SecureStore from 'expo-secure-store';
import { getAuthAPIBaseURL } from './api-url';
import { getAppScheme } from './app-scheme';
import { createTabbioExpoAuthPlugin } from './tabbio-expo-auth-plugin';

export const authClient = createAuthClient({
  baseURL: getAuthAPIBaseURL(),
  plugins: [
    createTabbioExpoAuthPlugin({
      scheme: getAppScheme(),
      disableCache: true,
      storage: SecureStore,
      storagePrefix: 'tabbio',
    }),
    emailOTPClient(),
    inferAdditionalFields({
      user: {
        username: {
          type: 'string',
          required: false,
          returned: true,
        },
        isOnboardingCompleted: {
          type: 'boolean',
          required: false,
          returned: true,
        },
        isUaePassVerified: {
          type: 'boolean',
          required: false,
          returned: true,
        },
      },
    }),
  ],
}) as any;

export const { signIn, signUp } = authClient;
